"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPalette = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconPalette = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 14.2091 21.2091 16 19 16H18.5C18.0038 16 17.8525 16.0022 17.7389 16.0171C16.8415 16.1353 16.1353 16.8415 16.0171 17.7389C16.0022 17.8525 16 18.0038 16 18.5V19C16 21.2091 14.2091 23 12 23C5.92487 23 1 18.0751 1 12ZM10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9C11.1046 9 12 8.10457 12 7C12 5.89543 11.1046 5 10 5ZM14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8ZM5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C13.6569 22 15 20.6569 15 19V18.5C15 18.0356 15 17.8034 15.0257 17.6084C15.2029 16.2622 16.2622 15.2029 17.6084 15.0257C17.8034 15 18.0356 15 18.5 15H19C20.6569 15 22 13.6569 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconPalette = IconPalette;
//# sourceMappingURL=IconPalette.js.map